export default {
  sites: [],
}
